export default selectedIntensityLevel =>
  ({ intensity }) =>
    intensity === null || intensity.match(selectedIntensityLevel.pattern) !== null;
